import * as React from 'react';

export interface UseBhanzuBuddyModeHandlersProps {
  setCurrentMode: (mode: 'explain' | 'guide') => void;
  setCurrentSource: (source: string) => void;
  hasScrolledOnOpen: React.RefObject<boolean>;
  leadId?: string;
  refetchWithSource?: (source: string) => void;
}

export const useBhanzuBuddyModeHandlers = ({
  setCurrentMode,
  setCurrentSource,
  hasScrolledOnOpen,
  leadId,
  refetchWithSource,
}: UseBhanzuBuddyModeHandlersProps) => {
  const handleToggleMode = React.useCallback(
    (mode: 'explain' | 'guide') => {
      setCurrentMode(mode);
      const newSource = mode === 'explain' ? 'explain_me' : 'guide_me';
      setCurrentSource(newSource);
      hasScrolledOnOpen.current = false;
      if (leadId && refetchWithSource) {
        // Clear current seeded history and fetch fresh interactions for the new mode
        refetchWithSource(newSource);
      }
    },
    [
      leadId,
      refetchWithSource,
      setCurrentMode,
      setCurrentSource,
      hasScrolledOnOpen,
    ]
  );

  return {
    handleToggleMode,
  };
};
